import { __awaiter } from "tslib";
import { useCallback } from 'react';
import checkFfpStatusVariablesFactory from './checkFfpStatusVariablesFactory';
import useFfpStatusCheck from './useFfpStatusCheck';
const useSaveLoyaltyWithFfpCheck = (passenger, onSaveLoyalty) => {
    const { checkFfpStatus, isLoading, error } = useFfpStatusCheck();
    const onSaveLoyaltyHandler = useCallback((code) => __awaiter(void 0, void 0, void 0, function* () {
        const travellers = checkFfpStatusVariablesFactory([
            { travellerId: passenger.id, values: passenger.values, loyaltyCode: code }
        ]);
        const errors = yield checkFfpStatus(travellers);
        if (!errors) {
            onSaveLoyalty(code);
        }
    }), [passenger, onSaveLoyalty, checkFfpStatus]);
    return { onSaveLoyaltyHandler, isLoading, error };
};
export default useSaveLoyaltyWithFfpCheck;
